<h2 mat-dialog-title>Allegati per "{{ disposizione?.titolo }}"</h2>

<mat-dialog-content>
  <div class="upload-section">
    <button mat-stroked-button color="primary" (click)="fileInput.click()" [disabled]="uploading">
      Carica allegato
      <mat-icon>upload</mat-icon>
    </button>
    <input #fileInput type="file" hidden (change)="onFileSelected($event)" />
    <mat-progress-bar *ngIf="uploading" mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="loading" class="loading-wrapper">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <table mat-table [dataSource]="allegati" *ngIf="!loading && allegati?.length" #table="matTable">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let allegato">{{ allegato.nome_originale }}</td>
    </ng-container>

    <ng-container matColumnDef="dimensione">
      <th mat-header-cell *matHeaderCellDef>Dimensione</th>
      <td mat-cell *matCellDef="let allegato">{{ allegato.dimensione | number }} bytes</td>
    </ng-container>

    <ng-container matColumnDef="azioni">
      <th mat-header-cell *matHeaderCellDef>Azioni</th>
      <td mat-cell *matCellDef="let allegato">
        <button mat-icon-button (click)="openDownload(allegato)" title="Scarica">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="deleteAllegato(allegato)" title="Elimina">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['nome', 'dimensione', 'azioni']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['nome', 'dimensione', 'azioni']"></tr>
  </table>

  <p *ngIf="!loading && !allegati?.length" class="empty-state">Nessun allegato presente.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef?.close()">Chiudi</button>
</mat-dialog-actions>
